import React, { useEffect } from 'react';
import styles from './CompanySettingsSSOTab.module.css';
import { SSOProviderCard } from './SSOProviderCard';
import { SSOProviderModal } from './SSOProviderModal';
import { SSO_PROVIDERS } from './const';

const CompanySettingsSSOTab = ({ companySettings, updateCompanySettings, isDirty }) => {
  const [selectedProvider, setSelectedProvider] = React.useState(null);
  const [isOpen, setIsOpen] = React.useState(false);
  const [dirtyProviders, setDirtyProviders] = React.useState({});

  useEffect(() => {
    if (!isDirty) {
      setDirtyProviders({});
    }
  }, [isDirty]);

  const ssoSettings = companySettings?.ssoSettings;

  const handleEdit = provider => {
    setIsOpen(true);
    setSelectedProvider(provider);
  };

  const handleDeactivate = provider => {
    dirtyProviders[provider.default.provider] = true;
    const updatedSSOSettings = (() => {
      if (ssoSettings?.identityProviders) {
        const filteredProviders = ssoSettings.identityProviders.filter(p => p.provider !== provider.default.provider);
        if (filteredProviders.length === 0) {
          return null;
        } else if (filteredProviders.length === 1) {
          return filteredProviders[0];
        } else {
          return filteredProviders;
        }
      }

      return null;
    })();
    updateCompanySettings(
      {
        target: {
          type: 'text',
          value: updatedSSOSettings
        }
      },
      companySettings,
      'ssoSettings'
    );
  };

  const handleActivate = provider => {
    setIsOpen(true);
    setSelectedProvider(provider.default);
  };

  const handleSaveProvider = () => {
    setIsOpen(false);
    dirtyProviders[selectedProvider.provider] = true;
    const updatedSSOSettings = (() => {
      if (!ssoSettings) {
        return { ...selectedProvider };
      } else if (ssoSettings.identityProviders) {
        const filteredProviders = ssoSettings.identityProviders.filter(p => p.provider !== selectedProvider.provider);
        return { identityProviders: [...filteredProviders, { ...selectedProvider }] };
      } else {
        if (ssoSettings.provider === selectedProvider.provider) {
          return selectedProvider;
        } else {
          return { identityProviders: [{ ...ssoSettings }, { ...selectedProvider }] };
        }
      }
    })();
    updateCompanySettings(
      {
        target: {
          type: 'text',
          value: updatedSSOSettings
        }
      },
      companySettings,
      'ssoSettings'
    );
  };

  return (
    <>
      <div className={styles.root}>
        {Object.keys(SSO_PROVIDERS).map(key => {
          const provider = SSO_PROVIDERS[key];
          return (
            <SSOProviderCard
              key={key}
              provider={provider}
              ssoSettings={ssoSettings}
              handleActivate={handleActivate}
              handleDeactivate={handleDeactivate}
              handleEdit={handleEdit}
              isDirty={dirtyProviders[key]}
            />
          );
        })}
      </div>
      <SSOProviderModal
        show={isOpen}
        provider={selectedProvider}
        onHide={() => setIsOpen(false)}
        onSave={() => handleSaveProvider()}
        onUpdateProvider={provider => setSelectedProvider(provider)}
      />
    </>
  );
};

export default CompanySettingsSSOTab;
